import PropTypes from 'prop-types';
import FoodCardOrderItem from './FoodCardOrderItem';

const FoodCardOrderList = ({ items, click }) => {
  return (
    <>
      {
        items.map((item, index) => {
          return (<FoodCardOrderItem key={'fco_' + index} name={item.name} img={item.img} action={click} />);
        })
      }

    </>
  );
};

FoodCardOrderList.propTypes = {
  items: PropTypes.array,
  click: PropTypes.func
};

export default FoodCardOrderList;
